import { Box, Grid, IconButton } from '@material-ui/core';
import { CustomTheme } from '@nemuru-eng/js-api-client';
import React from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '@/components/shared/components/Icon';
import { useLeftMenuStyle } from '@/components/shared/components/LeftMenu/hooks/useLeftMenuStyle';
import { Logo } from '@/components/shared/components/Logo/Logo';
import { MainMenu } from '@/components/shared/components/MainMenu';
import { MenuBottom } from '@/components/shared/components/MenuBottom';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { useUIWrapper } from '@/hooks/useUIWrapper';

export function LeftMenu() {
  const {
    state: { currentLayout, appTheme },
  } = useConfigContext();
  const {
    state: { showLeftMenu },
    actions: { setShowLeftMenu },
  } = usePageContext();

  const { palette, background, themeName } = useCustomTheme();
  const { md } = useScreen();
  const { leftMenuWidth } = useUIWrapper();
  const { classes } = useLeftMenuStyle(showLeftMenu);

  const drawerXPosition = appTheme && showLeftMenu ? 0 : 'calc(-75px - 100%)';

  const animationParams = {
    transition: 'transform 0.6s ease',
  };

  const wrapperStyle = {
    width: leftMenuWidth,
    height: '100%',
    position: 'fixed',
    borderRight: '1px solid',
    borderColor: palette.grey[200],
    opacity: appTheme ? 1 : 0.3,
    background: background,
    cursor: showLeftMenu ? 'default' : 'pointer',
    zIndex: 20,
    transform: `translateX(${drawerXPosition})`,
    ...animationParams,
  } as React.CSSProperties;

  return (
    <>
      <Box
        className={classes.root}
        style={wrapperStyle}
        onClick={(e) => {
          if (!showLeftMenu) {
            e.stopPropagation();
            setShowLeftMenu(true);
          }
        }}
      >
        <Grid
          container
          className="p-3"
          justifyContent="space-between"
          style={{
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '260px',
            margin: 'auto',
          }}
        >
          <Box style={{ maxWidth: '100%' }}>
            {currentLayout && (
              <>
                <Box
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    borderBottom: `1px solid ${palette.grey[300]}`,
                    marginBottom: '30px',
                  }}
                >
                  <Link to="/">
                    <Box
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '8px 0 24px',
                        height: '46px',
                      }}
                    >
                      <Box position="relative" top={(themeName as CustomTheme) === CustomTheme.NEMURU ? 8 : 0}>
                        <Logo />
                      </Box>
                    </Box>
                  </Link>
                </Box>
                <MainMenu />
              </>
            )}
          </Box>
          <Box style={{ maxWidth: '100%', marginTop: '20px' }}>
            <MenuBottom />
          </Box>
        </Grid>
        {md && (
          <Box
            width={0}
            zIndex={99}
            position={'absolute'}
            top={'80px'}
            right={'13px'}
            style={{
              ...animationParams,
            }}
          >
            <IconButton
              size="small"
              className={`${classes.nested} ${classes.button}`}
              onClick={() => setShowLeftMenu(!showLeftMenu)}
              style={{ border: `1px solid ${palette.grey[300]}` }}
            >
              <Icon
                style={{
                  background: 'transparent',
                  borderRadius: '50%',
                  transform: showLeftMenu ? 'none' : 'rotateY(180deg)',
                  transition: 'transform 1.2s ease',
                }}
                size={20}
              >
                {'chevron_left'}
              </Icon>
            </IconButton>
          </Box>
        )}
      </Box>
    </>
  );
}
